// Runtime exhaustiveness guard for the connection layer. Criterion 3 asks the
// hand-written connections to be "exhaustiveness-checked against Schema.ts": the
// mapped-type registry catches a missing entity at compile time, and this guard
// catches the rest at runtime — an owner/index edge whose FK field isn't indexed
// on its target, or a soft-delete declaration that drifts from the models. A
// future `Schema.ts` regen that adds an entity/edge the layer doesn't handle then
// fails loudly instead of silently mis-routing live updates.
//
// #1707 (tracker #1677) moved the actual guard into app-base's generic
// `validateSchema` (parameterized by a `SchemaDescriptor`, not Logbook's
// generated types); `Connections/Connection.ts#validateSchema` delegates to it
// against `logbookSchemaDescriptor`. This module stays as the thin, stably-named
// entry point every existing caller already imports.
import { validateSchema, type ConnectionRegistry } from "./Connections/Connection"
import { connections as defaultConnections } from "./Connections"

export function bindSchema(registry: ConnectionRegistry = defaultConnections): void {
  validateSchema(registry);
}
